import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string, portionLabel: string = 'Material') =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.Method`]: `Method`,
      [`${prefix}.Preparation.VisualNominalParticleSize`]: `Visual Nominal Particle Size`,

      [`${prefix}.Equipment.Balance`]: `Balance`,
      [`${prefix}.Equipment.DryMassBalance`]: `Dry Mass Balance`,
      [`${prefix}.Equipment.Oven`]: `Oven`,
      [`${prefix}.Equipment.DryingTemperature`]: `Drying Temperature`,

      [`${prefix}.DryingTray.ContainerLabel`]: `Tare ID`,
      [`${prefix}.DryingTray.ContainerMass`]: `Tare Mass`,
      [`${prefix}.DryingTray.WetSoilAndContainerMass`]: `Tare and ${portionLabel} Wet Mass`,
      [`${prefix}.DryingTray.WetSoilMass`]: `${portionLabel} Wet Mass`,
      [`${prefix}.DryingTray.ConstantDrySoilAndContainerMass`]: `Tare and ${portionLabel} Dry Mass`,
      [`${prefix}.DryingTray.ConstantDrySoilMass`]: `${portionLabel} Dry Mass`,

      [`${prefix}.DryingTray.DateTimePlacedInOvenLocal`]: `Date and Time in Oven`,

      [`${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: `Tare and ${portionLabel} Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DrySoilMass`]: `${portionLabel} Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DateTimeRemovedFromOvenLocal`]: `Date and Time Out of Oven`,
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: `Drying Time`,

      [`${prefix}.Results.MoistureContentPercent`]: `Water Content`,
      [`${prefix}.Results.ReportInsufficientSampleMass`]: `Report Insufficient Sample Mass`,
      [`${prefix}.Results.ReportDryingTemperature`]: `Report Drying Temperature`,
      [`${prefix}.Results.ReportMaterialExcluded`]: `Report Material Excluded`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.MoistureContentPercent`]: '%',
    })
  );

export default getLabelConfig;
